<template>
    <div class="cost">
        <header>
            <Header />
        </header>
        <div class="cost-content-box">
            <div class="content-box-data">
                <div class="cost-box">
                    <div class="cost-box-title">个人中心</div>
                    <div class="cost-box-desc">管理您的账户信息和渠道收益信息</div>
                </div>
                <el-card class="box-card">
                    <el-tabs tab-position="left">
                        <el-tab-pane label="账号信息">
                            <UserTable />
                        </el-tab-pane>
                        <!-- <el-tab-pane label="费用统计">
                            <costTable />
                        </el-tab-pane>
                        <el-tab-pane label="佣金管理">
                            <commissionTable />
                        </el-tab-pane> -->
                        <el-tab-pane label="渠道用户">
                            <channelUserTable />
                        </el-tab-pane>
                        <el-tab-pane label="收益管理">
                            <incomeTable />
                        </el-tab-pane>
                        <el-tab-pane label="提现管理">
                            <!-- 总收益、cc、可提现收益、提现中收益 -->
                            <!--  -->
                            <withdrawTable />
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </div>
        </div>
        
    </div>
</template>

<script>
import Header from '../../components/header.vue';
import UserTable from './userAccount.vue'
// import costTable from './Channel/cost'
// import commissionTable from './Channel/commission'
import channelUserTable from './Channel/channelUser.vue';
import incomeTable from './Channel/income.vue';
import withdrawTable from './Channel/withdraw.vue';
export default {
    // name:'个人中心-渠道用户',
    components: {
		Header,
        UserTable,
        // costTable,
        // commissionTable
        channelUserTable,
        incomeTable,
        withdrawTable,
	},
    data() {
        return {
        
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>
<style lang="scss" scoped>
.cost-content-box{
    width: 100%;
	height:auto;
    min-height:calc(100vh - 140px);
	padding:30px 0 20px;
	background-color: #f9fafb;
    .content-box-data{
        width:80%;
        height:auto;
        margin:0 auto;
        // background-color:#fff;
        .cost-box{
            width:100%;
            height:auto;
            margin-bottom:20px;
            box-sizing: border-box;
            padding:20px 20px;
            border-radius:5px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            background-color:#fff;
            .cost-box-title{
                font-size:1.25rem;
                font-weight:600;
                color:#000;
            }
            .cost-box-desc{
                font-size:0.8rem;
                color:#666;
                margin-top:10px;
            }
        }
        // .box-card-title{
        //     width: 100%;
        //     font-size:0.8rem;
        //     font-weight:600;
        //     text-align: center;
        //     margin-bottom:20px;
        // }
        // .cost-form{
        //     width:500px;
        //     height:auto;
        //     margin:0 auto;
        // }
    }
}
</style>